const initialPageInfo = {
  totalCount: 0,
  totalPageCount: 0,
  startCursor: '',
  endCursor: '',
}
const state = {
  initialPageInfo,
  coachVisitTime: 0,
}

const getters = {
  coachVisitTime(state) {
    return state.coachVisitTime
  },
  totalCount(state) {
    return state.totalCount
  },
  totalPageCount(state) {
    return state.totalPageCount
  },
}

const mutations = {
  CLEAR(state) {
    state.totalCount = this.initialPageInfo.totalCount
    state.totalPageCount = this.initialPageInfo.totalPageCount
    state.startCursor = this.initialPageInfo.startCursor
    state.endCursor = this.initialPageInfo.endCursor
  },
  SET(state, pageInfo) {
    state.totalCount = pageInfo.totalCount
    state.totalPageCount = pageInfo.totalPageCount
    state.startCursor = pageInfo.startCursor
    state.endCursor = pageInfo.endCursor
  },
  UPDATE_COACH_VISIT_TIME(state) {
    state.coachVisitTime += 1
  },
}

const actions = {
  clear({ commit }) {
    commit('CLEAR')
  },
  setPageInfo({ commit }, pageInfo) {
    commit('SET', pageInfo)
  },
  updateCoachVisitTime({ commit }) {
    commit('UPDATE_COACH_VISIT_TIME')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
